// composables/useErpTouch.js
import { ERROR_CODE, PAYMENT_CASH, SUCCESS_CODE} from "~/constants/constantes_varias";
import { batteryDto, batteryPdpDto, mockServicesResponse, mockLogisticsResponse, mockLogisticsNoResponse, servicesDto, logisticsDto } from "@/utils/batteryDto";
import { tireGetDto, tirePdpGetDto } from "@/utils/tireDto";

export default function useErpTouch() {
  const config = useRuntimeConfig();
  
  const debug = {
    enabled: config.public.modo === 'DEV',
    log(...args) {
      if (this.enabled) console.log(...args);
    },
    error(...args) {
      if (this.enabled) console.error(...args);
    },
  };

  //dc: las consultas se estan pasando al backend...

  //#region GRUPO 1 (neumaticos): ancho, perfil, aro
  const getWidths = async () => {
    
    try {
      if (import.meta.server) {
        debug.log("Estas en server aun...");
        return [];
      }

      debug.log("getWidths() iniciando consulta");
      const widths = await $fetch("/api/neumaticos", {
        params: { action: "anchos" },
      });
      debug.log("useErpTouch widths: ", widths);
      return widths;
    } catch (error) {
      console.log("Error en getWidths:", error);
      return [];
    }
  };

  const getProfiles = async (width) => {
    try {
      if (import.meta.server) {
        debug.log("Estas en server aun...");
        return [];
      }

      debug.log("getProfiles() para width:", width);
      const profiles = await $fetch("/api/neumaticos", {
        params: {
          action: "perfiles",
          width,
        },
      });
      debug.log("useErpTouch profiles: ", profiles);
      return profiles;
    } catch (error) {
      console.log("Error en getProfiles:", error);
      return [];
    }
  };

  const getRings = async (width, profile) => {
    try {
      if (import.meta.server) {
        debug.log("Estas en server aun...");
        return [];
      }
      debug.log("getRings() para width/profile:", width, profile);
      const rings = await $fetch("/api/neumaticos", {
        params: {
          action: "aros",
          width,
          profile,
        },
      });
      debug.log("useErpTouch rings: ", rings);
      return rings;
    } catch (error) {
      console.log("Error en getRings:", error);
      return [];
    }
  };
  //#endregion

  //#region GRUPO 2 (productos): getPlpNeumaticosByLocal, getPlpMulti, getPdpNeumaticosByLocal, getStock, getServices, getLogisticsRoutes

  //POST envio objetos complejos
  //PLP DOBLE
  const getPlpMulti = async (local, vehicle) => {
    try {

      debug.log("getPlpMulti neu local:", local);
      debug.log("getPlpMulti neu vehicle:", vehicle);

      const response = await $fetch("/api/productos", {
        method: "POST",
        body: {
          action: "getPlpMulti",
          local,
          vehicle, // Aquí vehicle ya es un array de objetos
        },
      });

      debug.log("getPlpMulti neu response:", response);
      let ajustedto = tireGetDto(response);
      debug.log("getPlpMulti neu ajustedto:", ajustedto);

      return ajustedto;
    } catch (error) {
      console.log("Error en getPlpMulti:", error);
      return [];
    }
  };

  const getVerificarPrecios = async (productos, local_id) => {
    try {
      //console.log('useErpTouch - getVerificarPrecios, productos:', productos);
      //console.log('useErpTouch - getVerificarPrecios, local_id:', local_id);

      const response = await $fetch('/api/productos', {
        method: 'POST',
        body: {
          action: 'verificarPrecio',
          productos: productos,  // Ya vienen formateados desde
          local_id: local_id
        }
      });

      //console.log('useErpTouch - getVerificarPrecios, response:', response);
      return response;
    } catch (error) {
      console.error('useErpTouch - getVerificarPrecios, error:', error);
      throw error;
    }
  };

  //POST envio objetos complejos
  const getStock = async (products) => {
    try {
      //console.log("getStock, products: ", products);

      const response = await $fetch("/api/productos", {
        method: "POST",
        body: {
          action: "getStock",
          products,
        },
      });
      //console.log("getStock, response:", response);
      return response;
    } catch (error) {
      console.log("Error en getStock:", error);
      return [];
    }
  };

  //POST en el backend se encuentra como post
  const getServices = async (local, business, ring, marcas = []) => {
    try {
      let aro = ring;

      if(business==2){
        aro = null;
      }

      debug.log("13-08-25 getServices local:", local);
      debug.log("13-08-25 getServices business:", business);
      debug.log("13-08-25 getServices ring:", ring);
      debug.log("13-08-25 getServices marcas:", marcas);

      let response;
      response = await $fetch("/api/productos", {
        method: "POST",
        body: {
          action: "getServices",
          local_id: local,
          negocio_id: business,
          aro: aro,
          marca: marcas,
        },
      });

      debug.log("13-08-25 getServices response:", response);
      return response;
    } catch (error) {
      console.log("Error en getServices:", error);
      return {};
    }
  };

  const getPlpNeumaticosByLocal = async (local, width, profile, ring, stock = 1) => {
    try {
      debug.log("DEBUG neu negocio_id:", 1);
      debug.log("DEBUG neu local_id:", local);
      debug.log("DEBUG neu ancho:", width);
      debug.log("DEBUG neu perfil:", profile);
      debug.log("DEBUG neu aro:", ring);
      debug.log("DEBUG neu stock_minimo:", stock);

      const response = await $fetch("/api/productos", {
        method: "POST",
        body: {
          action: "getPlpNeumaticosByLocal",
          negocio_id: 1,
          local_id: local,
          ancho: width,
          perfil: profile,
          aro: ring,
          stock_minimo: stock
        },
      });

      debug.log("DEBUG neu response:", response);
      let ajustedto = tireGetDto(response);
      debug.log("DEBUG neu ajustedto:", ajustedto);

      return ajustedto;
    } catch (error) {
      console.error("Error en :", error);
      return [];
    }
  };

  //GET
  const getPdpNeumaticosByLocal = async (local, code) => {
    try {
      debug.log("getPdpNeumaticosByLocal() local: ", local, "|code: ", code);
      const response = await $fetch("/api/productos", {
        method: "POST",
        body: {
          action: "getPdpNeumaticosByLocal",
          codigo: code,
          local_id: local,
          negocio_id: 1,
        },
      });

      debug.log("1. getPdpNeumaticosByLocal response:", response);
      const procesado = tirePdpGetDto(response);
      debug.log("2. getPdpNeumaticosByLocal procesado:", procesado);

      return procesado;
    } catch (error) {
      console.log("Error en getPdpNeumaticosByLocal:", error);
      return {};
    }
  };

  //#endregion

  //#region GRUPO 3 (preorden): createPreOrder, confirmPreOrder
  const createPreOrder = async (data) => {
    try {
      debug.log("createPreOrder() iniciando...", data);

      const response = await $fetch("/api/preorden", {
        method: "POST",
        body: {
          action: "createPreOrder",
          ...data,
        },
      });

      return response;
    } catch (error) {
      console.log("Error en createPreOrder:", error);
      return {
        status: ERROR_CODE,
      };
    }
  };

  const confirmPreOrder = async (data) => {
    try {
      debug.log("CPreOrder() iniciando...", data);

      const response = await $fetch("/api/preorden", {
        method: "POST",
        body: {
          action: "confirmPreOrder",
          uuid: data.uuid,
          payMode: data.payMode,
          urlSuccess: data.urlSuccess,
          urlFailed: data.urlFailed,
          urlCanceled: data.urlCanceled,
          urlTimeout: data.urlTimeout,
        },
      });

      debug.log("CPreOrder() response:", response);
      return response;
    } catch (error) {
      console.log("Error en CPreOrder:", error);
      return {};
    }
  };

  // ==================== VERSIONES SEGURAS ====================
  const createPreOrderSecure = async (data) => {
    try {
      debug.log("cPreOrderSecure() iniciando...", data);

      const response = await $fetch("/api/preorden", {
        method: "POST",
        body: {
          action: "createPreOrderSecure",
          ...data,
        },
      });

      return response;
    } catch (error) {
      console.log("Error en cPreOrderSecure:", error);
      return {
        status: ERROR_CODE,
      };
    }
  };

  const confirmPreOrderSecure = async (data) => {
    try {
      debug.log("cPreOrderSecure() iniciando...", data);

      const response = await $fetch("/api/preorden", {
        method: "POST",
        body: {
          action: "confirmPreOrderSecure",
          uuid: data.uuid,
          payMode: data.payMode,
          urlSuccess: data.urlSuccess,
          urlFailed: data.urlFailed,
          urlCanceled: data.urlCanceled,
          urlTimeout: data.urlTimeout,
        },
      });

      debug.log("cPreOrderSecure() response:", response);
      return response;
    } catch (error) {
      console.log("Error en cPreOrderSecure:", error);
      return {};
    }
  };
  //#endregion
  
  //#region GRUPO 4 (locales): getLocalesPorRegionPorComuna, get_locales_full

  const getLocalesPorRegionPorComuna = async (region, commune) => {
    try {
        debug.log("getLocalesPorRegionPorComuna en useErpTouch.js consultando tiendas por región y comuna.");
        
        // Ahora llamamos a nuestro endpoint interno de Nuxt en lugar de la API externa directamente
        const response = await $fetch('/api/locales', {
            method: 'GET',
            params: {
                action: 'getLocalesPorRegionPorComuna',
                region,
                commune
            }
        });
        
        debug.log("getLocalesPorRegionPorComuna response:", response);
        
        if (response.status === 'success') {
            return response.data; // Los datos ya vienen validados del servidor
        } else {
            console.error("Error en la respuesta del servidor:", response);
            return [];
        }
    } catch (error) {
        console.error("Error al obtener tiendas por región y comuna:", error);
        return [];
    }
  };

  const get_locales_full = async () => {
    try {
      debug.log("get_locales_full en useErpTouch.js consultando todos los locales incluyendo asociados.");
  
      // Ahora llamamos a nuestro endpoint interno de Nuxt en lugar de la API externa directamente
      const response = await $fetch('/api/locales', {
        method: 'GET',
        params: {
          action: 'locales-full'
        }
      });
      
      debug.log("get_locales_full response:", response);
      
      if (response.status === 'success') {
        return response.data; // Los datos ya vienen validados del servidor
      } else {
        console.error("Error en la respuesta del servidor:", response);
        return [];
      }
    } catch (error) {
      console.error("Error al obtener locales:", error);
      return [];
    }
  };
  //#endregion

  //#region GRUPO 5 (logistica): getLogisticCalendar, getServiceTime

  // POST en el backend se encuentra como post
  const getLogisticCalendar = async (store, business, minutes) => {
    try {
      // Verificación mejorada que no falla con valores como 0
      if (store === undefined || store === null || 
          business === undefined || business === null || 
          minutes === undefined || minutes === null) {
        console.error("Faltan parámetros requeridos:", { store, business, minutes });
        return {};
      }
      
      //console.log("DEBUG 11-08-25 getLogisticCalendar() para store/business/minutes:", store, business, minutes);
      
      const response = await $fetch("/api/logistica", {
        method: "POST",
        body: {
          action: "getLogisticCalendar",
          store,
          business,
          minutes
        }
      });
      
      //console.log("DEBUG 11-08-25 getLogisticCalendar response:", response);
      
      return response;
    } catch (error) {
      console.error("Error en getLogisticCalendar:", error);
      return {};
    }
  };

  //POST envio objetos complejos  
  //POST por comodidad en el envio de objetos
  const getLogisticsRoutes = async (store, products, businessId, modalidad) => {
    try {
      //console.log("DEBUG 11-08-25 DEBUG getLogisticsRoutes store:", store);
      //console.log("DEBUG 11-08-25 DEBUG getLogisticsRoutes products:", products);
      //console.log("DEBUG 11-08-25 DEBUG getLogisticsRoutes businessId:", businessId);
      //console.log("DEBUG 11-08-25 DEBUG getLogisticsRoutes modalidad:", modalidad);
      const productsMap = products.map((item) => ({
        codigo: item.product.codigo,
        cantidad: item.quantity,
      }));

      const response = await $fetch("/api/productos", {
        method: "POST",
        body: {
          action: "getLogisticsRoutes",
          store,
          products: productsMap,
          businessId,
          modalidad,
        },
      });
      //console.log("DEBUG 11-08-25 getLogisticsRoutes response:", response);
      return response;
    } catch (error) {
      console.error("Error en getLogisticsRoutes:", error);
      return {};
    }
  };

  // GET
  const getServiceTime = async (store, business) => {
    try {
      debug.log("getServiceTime() para store/business:", store, business);
      
      const response = await $fetch("/api/logistica", {
        params: {
          action: "getServiceTime",
          store,
          business
        }
      });
      
      debug.log("getServiceTime response:", response);
      
      return response; // El formato ya se verifica en el servidor
    } catch (error) {
      console.error("Error en getServiceTime:", error);
      return "";
    }
  };

  //#endregion

  //#region GRUPO 6 (cliente): /cliente/buscar/, /cliente/procesar

  // GET
  const getClient = async (email) => {
    try {
      debug.log("getClient() para email:", email);
      
      const response = await $fetch("/api/cliente", {
        params: {
          action: "getClient",
          email
        }
      });
      
      debug.log("getClient response:", response);
      
      return response; // La validación ya se realiza en el servidor
    } catch (error) {
      console.error("Error en getClient:", error);
      return [];
    }
  };

  // POST en el backend se encuentra como post
  const storeClient = async (email, name, lastname, surname, phone, country) => {
    try {
      debug.log("storeClient() iniciando...");
      
      const response = await $fetch("/api/cliente", {
        method: "POST",
        body: {
          action: "storeClient",
          email,
          nombre: name,
          apellido_paterno: lastname,
          apellido_materno: surname,
          celular: phone,
          pais: country
        }
      });
      
      debug.log("storeClient response:", response);
      
      return response; // La validación ya se realiza en el servidor
    } catch (error) {
      console.error("Error en storeClient:", error);
      return [];
    }
  };
  //#endregion


  // ----------------------------------------------------------------------------------
  //#region PROYECTO BATERIAS BOREALIS
  const validateArrObjAndReturn = (response, validator) => {
    if (Array.isArray(response) && response.length > 0) {
      const hasValidObjects = response.every(validator);
      return hasValidObjects ? response : [];
    } else {
      return [];
    }
  };

  const hasValidProperties = (response, properties) => {
    const hasValidProperties = properties.every((prop) => response.hasOwnProperty(prop));
    return hasValidProperties ? response : {};
  };

  const getPlpBatteryByLocal = async (local, carPlate, batteryInstallType) => {
    try {
      const response = await $fetch("/api/productos", {
        method: "POST",
        body: {
          action: "getPlpBatteryByLocal",
          local_id: local,
          negocio_id: 2,
          patente: carPlate,
          modalidad_id: batteryInstallType,
        },
      });
      debug.log("getPlpBatteryByLocal() - response: ", response);
      return batteryDto(response);
    } catch (error) {
      console.error("Error en :", error);
      return [];
    } finally {
    }
  };

  const getPdpBatteryByLocal = async (local, code, carPlate, batteryInstallType) => {
    try {
      debug.log("getPdpBatteryByLocal(): ", local, "|code: ", code);

      const response = await $fetch("/api/productos", {
        method: "POST",
        body: {
          action: "getPdpBatteryByLocal",
          codigo: code,
          local_id: local,
          negocio_id: 2,
          patente: carPlate,
          modalidad_id: batteryInstallType,
        },
      });

      debug.log("response DEBUG: ", response);
      return batteryPdpDto(response);
    } catch (error) {
      return {};
    }
  };

  //TODO: FIN DE BORRAR CUANDO SE QUITEN LOS MOCKS
  //#endregion

  return {
    getWidths,
    getProfiles,
    getRings,
    getStock,
    getVerificarPrecios,
    getLocalesPorRegionPorComuna,
    getServices,
    getLogisticsRoutes,
    getServiceTime,
    getLogisticCalendar,
    getClient,
    storeClient,
    createPreOrder,
    confirmPreOrder,
    createPreOrderSecure,
    confirmPreOrderSecure,
    getPlpMulti,
    getPdpNeumaticosByLocal,
    get_locales_full,
    getPlpNeumaticosByLocal,
    getPlpBatteryByLocal,
    getPdpBatteryByLocal,
  };
}
